export default "__VITE_ASSET__BM_QXtoO__"